import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import SaveButton from "@/components/SaveButton";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

export default function PayrollDepartmentEditorFooter() {
  const { t } = useTranslation();
  const { deleteMutation } = useDictionaryContext();
  const { formState } = useFormContext();

  return (
    <div className="flex justify-end gap-2">
      <Button
        variant="destructive"
        onClick={deleteMutation?.mutateAsync}
        disabled={formState.disabled}
      >
        <Trash2 className="w-4 h-4" />
        {t("payrollDepartments.delete")}
      </Button>
      <SaveButton />
    </div>
  );
}
